<template>
	<div class="container-fluid">
		<div class="row">
			<div class="col mb-4">
				<div class="card shadow-sm">
					<div class="card-header">
						<h4 class="my-0 font-weight-normal">Release Information</h4>
					</div>
					<div class="card-body">
						<h5>Public Release is Coming Soon!</h5>
						<p>Please let us know if you'd like to join upcoming BETA testing.</p>
						<br>
						<h5>Widenode for Startup, Business and Enterprise</h5>
						<p>
							Via custom installation, Widenode is functional and ready for deployment.
							We've had it running in enterprise level production environments since mid 2018.
						</p>
						<p>
							Please get in touch for a full demo of the product.
						</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

import { mapState, mapGetters, mapActions, mapMutations } from "vuex";

export default {
	name: "release-view",
	computed:
	{
		...mapGetters( "nodes", {
			getNode: "node", // map STATE projects/all to "projects" AS A FUNCTION, which requires the nodeId as input!
			homeNode: "homeNode",
			parentNode: "parent",	// FUNCTION
		}),
	}
};
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Release.vue